import React, { useState, useEffect } from "react";

import Service from "../../Service/firebase";
import { GENDER_OPTIONS } from "../../constant/categoryGroups";

import "./newsubcategoryform.css";
const NewServiceForm = (props) => {
  const [categories, setCategories] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [vendorCodeError, setVendorCodeError] = useState("");

  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      onFetchCategories();
      onFetchVendors();
    }
    return () => {
      isSubscribed = false;
    };
  }, []);

  const onFetchCategories = async () => {
    setIsLoading(true);
    const fetchedDataList = await Service.getAllData("category");
    if (fetchedDataList.length > 0) {
      setCategories(fetchedDataList);
    }
    setIsLoading(false);
  };

  const onFetchVendors = async () => {
    const fetchedDataList = await Service.getAllData("vendors");
    if (fetchedDataList.length > 0) {
      setVendors(fetchedDataList);
    }
  };

  const handleCategoryChange = async (e) => {
    const categoryId = e.target.value;
    props.onEdit(e);
    const groups = await Service.getServiceGroupsByCategoryId(categoryId);
    setGroupOptions(groups);
  };

  return (
    <form onSubmit={props.handleSubmit}>
      <div className="container">
        {/* Vendor Code - hidden/readonly for vendor roles */}
        {props.isVendorLocked ? (
          // Vendor role: vendor is fixed, no need to show/edit vendor code
          <input type="hidden" name="vendorCode" value={props.defaultVendorCode || ""} />
        ) : (
        <div className="form-row">
          <div className="col-md-6 mb-3">
            <label htmlFor="vendorCode">
              Vendor Code <span style={{ color: "red" }}>*</span>
            </label>
            <input
              name="vendorCode"
              type="text"
              className="form-control"
              id="vendorCode"
              placeholder="Enter vendor code"
              defaultValue={props.defaultVendorCode || ""}
              onChange={props.onEdit}
              onBlur={(e) => {
                const code = e.target.value;
                if (code && !vendors.find((v) => v.vendorCode === code)) {
                  setVendorCodeError("Vendor code not found");
                } else {
                  setVendorCodeError("");
                }
              }}
              required
            />
            {vendorCodeError && (
              <small style={{ color: "red" }}>{vendorCodeError}</small>
            )}
          </div>
        </div>
        )}

        {/* Category */}
        <div className="form-row">
          <div className="col-md-6 mb-3">
            <label htmlFor="categoryId">
              Category <span style={{ color: "red" }}>*</span>
            </label>
            <select
              name="categoryId"
              id="categoryId"
              className="form-control"
              onChange={handleCategoryChange}
              required
            >
              <option value="">Select Category</option>
              {categories.map((option) => (
                <option key={option.categoryId} value={option.categoryId}>
                  {option.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Group */}
        {groupOptions.length > 0 && (
          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label htmlFor="group">Group</label>
              <select
                name="group"
                id="group"
                className="form-control"
                onChange={props.onEdit}
              >
                <option value="">Select Group</option>
                {groupOptions.map((g) => (
                  <option key={g} value={g}>
                    {g}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        {/* Service Name */}
        <div className="form-row">
          <div className="col-md-6 mb-3">
            <label htmlFor="serviceName">
              Service Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              name="serviceName"
              type="text"
              className="form-control"
              id="serviceName"
              onChange={props.onEdit}
              required
            />
          </div>
        </div>

        {/* Gender */}
        <div className="form-row">
          <div className="col-md-6 mb-3">
            <label htmlFor="gender">
              For (Gender) <span style={{ color: "red" }}>*</span>
            </label>
            <select
              name="gender"
              id="gender"
              className="form-control"
              onChange={props.onEdit}
              required
            >
              <option value="">Select Gender</option>
              {GENDER_OPTIONS.map((g) => (
                <option key={g.value} value={g.value}>
                  {g.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Price row */}
        <div className="form-row">
          <div className="col-md-3 mb-3">
            <label htmlFor="actualPrice">
              Actual Price (₹) <span style={{ color: "red" }}>*</span>
            </label>
            <input
              name="actualPrice"
              type="number"
              className="form-control"
              id="actualPrice"
              onChange={props.onEdit}
              required
            />
          </div>
          <div className="col-md-3 mb-3">
            <label htmlFor="offerPrice">
              Offer Price (₹) <span style={{ color: "red" }}>*</span>
            </label>
            <input
              name="offerPrice"
              type="number"
              className="form-control"
              id="offerPrice"
              onChange={props.onEdit}
              required
            />
          </div>
        </div>

        {/* Duration */}
        <div className="form-row">
          <div className="col-md-3 mb-3">
            <label htmlFor="serviceTime">
              Duration (min) <span style={{ color: "red" }}>*</span>
            </label>
            <input
              name="serviceTime"
              type="number"
              className="form-control"
              id="serviceTime"
              onChange={props.onEdit}
              required
            />
          </div>
        </div>

        {/* Description */}
        <div className="form-row">
          <div className="col-md-6 mb-3">
            <label htmlFor="description">Description</label>
            <textarea
              name="description"
              className="form-control"
              id="description"
              onChange={props.onEdit}
              rows="2"
            ></textarea>
          </div>
        </div>

        {/* Flags row */}
        <div className="form-row">
          <div className="col-md-6 mb-3" style={{ display: "flex", gap: "20px" }}>
            <label>
              <input
                name="isActive"
                type="checkbox"
                defaultChecked={true}
                onChange={props.onEdit}
              />{" "}
              Active
            </label>
            <label>
              <input
                name="isPackage"
                type="checkbox"
                onChange={props.onEdit}
              />{" "}
              Is Package
            </label>
          </div>
        </div>
      </div>

      {/* Image section */}
      <div className="container">
        <div className="row second_section">
          <div className="clo-sm-6">
            <div className="profile_image">{props.htmlelement}</div>
          </div>
          <div className="col-sm-6 btn_section">
            <label htmlFor="serviceImageUpload" className="selectimage">
              Upload Service Image
            </label>
            <input
              name="image"
              id="serviceImageUpload"
              type="file"
              onChange={props.onImageChange}
            />
            <button
              type="button"
              className="removebutton"
              onClick={props.onImageRemove}
            >
              Remove
            </button>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "20px", marginBottom: "20px" }}>
        <button
          className="btn btn-success savebtn"
          type="submit"
          style={{ marginRight: "10px" }}
        >
          Save
        </button>
        <button
          className="btn btn-secondary"
          type="button"
          onClick={props.onCancel}
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default NewServiceForm;
